import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Skeleton } from '@/components/ui/skeleton'

interface CreatorScoreBadgeProps {
  score: number | null | undefined
  variant?: 'small' | 'normal'
  className?: string
}

function getScoreColor(score: number): string {
  if (score >= 86) return 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30'
  if (score >= 71) return 'bg-green-500/20 text-green-400 border-green-500/30'
  if (score >= 51) return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30'
  if (score >= 31) return 'bg-orange-500/20 text-orange-400 border-orange-500/30'
  return 'bg-red-500/20 text-red-400 border-red-500/30'
}

function getScoreLabel(score: number): string {
  if (score >= 86) return 'Elite'
  if (score >= 71) return 'Strong'
  if (score >= 51) return 'Growing'
  if (score >= 31) return 'Developing'
  return 'Starting'
}

export function CreatorScoreBadge({ score, variant = 'normal', className = '' }: CreatorScoreBadgeProps) {
  if (score === null || score === undefined) {
    if (variant === 'small') return null
    return <Skeleton className="h-6 w-20 rounded-full" />
  }

  const colorClass = getScoreColor(score)
  const label = getScoreLabel(score)

  if (variant === 'small') {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}>
              {score}
            </span>
          </TooltipTrigger>
          <TooltipContent>
            <p>Creator Score: {score}/100 ({label})</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border ${colorClass} ${className}`}>
            <span className="text-sm font-semibold">{score}</span>
            <span className="text-xs opacity-80">Creator Score</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{label} creator - Based on virality analysis of your posts</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
